module.exports = __webpack_public_path__ + "img/Icone_200.3f3de789.svg";